import React from "react";
import PropTypes from "prop-types";
import ChatThreadItem from "./ChatThreadItem";

const ChatSidebar = ({
  currentView,
  onViewChange,
  searchQuery,
  onSearchChange,
  filter,
  onFilterChange,
  threads,
  selectedThreadId,
  pinned,
  onThreadSelect,
  onPin,
  onArchive,
  showChatOnMobile,
}) => {

  return (
    <aside className={`card sidebar ${showChatOnMobile ? "show-chat" : ""}`}>
      <div className="tabs">
        <div 
          className={`tab ${currentView === "chats" ? "active" : ""}`} 
          onClick={() => onViewChange("chats")}
        >
          Live Chat
        </div>
        <div 
          className={`tab ${currentView === "room" ? "active" : ""}`} 
          onClick={() => onViewChange("room")}
        >
          Room Chat
        </div>
      </div>
      <div className="search">
        <input 
          placeholder="Search..." 
          value={searchQuery} 
          onChange={(e) => onSearchChange(e.target.value)} 
        />
      </div>
      <div className="filter-tabs">
        <div 
          className={`filter-tab ${filter === "all" ? "active" : ""}`} 
          onClick={() => onFilterChange("all")}
        >
          all
        </div>
        <div 
          className={`filter-tab ${filter === "active" ? "active" : ""}`} 
          onClick={() => onFilterChange("active")}
        >
          active
        </div>
        <div 
          className={`filter-tab ${filter === "pinned" ? "active" : ""}`} 
          onClick={() => onFilterChange("pinned")}
        >
          pinned
        </div>
        <div 
          className={`filter-tab ${filter === "archived" ? "active" : ""}`} 
          onClick={() => onFilterChange("archived")}
        >
          archived
        </div>
      </div>
      <div className="threads">
        {threads.map((thread) => (
          <ChatThreadItem
            key={thread.id}
            thread={thread}
            isActive={selectedThreadId === thread.id}
            isPinned={pinned.has(thread.id)}
            onSelect={() => onThreadSelect(thread)}
            onPin={() => onPin(thread.id)}
            onArchive={() => onArchive(thread.id)}
          />
        ))}
      </div>
    </aside>
  );
};

ChatSidebar.propTypes = {
  currentView: PropTypes.string.isRequired,
  onViewChange: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  filter: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  threads: PropTypes.array.isRequired,
  selectedThreadId: PropTypes.string,
  pinned: PropTypes.instanceOf(Set).isRequired,
  onThreadSelect: PropTypes.func.isRequired,
  onPin: PropTypes.func.isRequired,
  onArchive: PropTypes.func.isRequired,
  showChatOnMobile: PropTypes.bool,
};

ChatSidebar.defaultProps = {
  selectedThreadId: "",
  showChatOnMobile: false,
};

export default ChatSidebar;

